import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import SkincareSliderSection from "../components/partials/SkincareDetail/SkincareSliderSection";

const HealthWellness = () => {
  const [language, setLanguage] = useState(Cookies.get("RashaLang") || "en");

  useEffect(() => {
    window.scrollTo(0, 0);
    const interval = setInterval(() => {
      const currentLang = Cookies.get("RashaLang") || "en";
      setLanguage((prev) => {
        if (prev !== currentLang) return currentLang;
        return prev;
      });
    }, 1000); // check every second

    return () => clearInterval(interval);
  }, []);



  const images = ["/assets/images/Health-Wellness/Health-Wellness-1.jpg"];

  const HealthWellnessSliderSectionTranslations = {
    en: {
      title: "Pharmanex",
      description:
        "Does your busy lifestyle make it hard for you to manage your body shape? These products contain a variety of vitamins and minerals, and some provide targeted nutrients for specific nutritional needs.",
      button: "Order Now!",
    },
    ar: {
      title: "فارمانيكس",
      description:
        "هل يصعّب نمط حياتكِ المزدحم الحفاظ على شكل جسمك؟ تحتوي هذه المنتجات على مجموعة متنوعة من الفيتامينات والمعادن، وبعضها يوفر مغذيات مستهدفة لاحتياجات غذائية معينة.",
      button: "اطلب الآن!",
    },
  };

  return (
    // <SecondLayout>
      <div className="container">
        <SkincareSliderSection
          translations={HealthWellnessSliderSectionTranslations}
          images={images}
          lang={language}
          link={"/order"}
        />
      </div>
    //   <div className="container">
    //     <ProductGrid lang={language} kits={kits} translations={translations} link={"/health-wellness-order-page"} />
    //   </div>
    // </SecondLayout>
  );
};

export default HealthWellness;
